$ = require 'jquery'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class OrganizationRestrictBoardVisibilityView extends View
  viewTitleKey: 'board creation restrictions'

  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @render

  events:
    'click a': 'changeRestriction'

  render: ->
    data = @model.toJSON(prefs: true)

    @$el.html(
      templates.fill(
        'org_prefs_vis',
        data
      )
    )

    @

  changeRestriction: (e) ->
    $target = $(e.target)

    prefName = "boardVisibilityRestrict/" + $target.closest('ul').attr('data-vis')
    setting = $target.attr('data-restriction')

    @model.setPref(prefName, setting)



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-restrict-board-visibility-view.coffee